<div class="button-option-container">
    <div class="option">
        <div>
            {{ 'mimic.settings.button-intercation.disabled' | translate }}
        </div>
        <div class="disabled-option-toggle">
            <div>
                <ng-container *ngIf="!disabledOptionIsOpen">
                    {{ 'mimic.settings.button-intercation.inactive' | translate }}
                </ng-container>
                <ng-container *ngIf="disabledOptionIsOpen">
                    {{ 'mimic.settings.button-intercation.active' | translate }}
                </ng-container>
            </div>
            <mat-slide-toggle
                class="toggle"
                [checked]="disabledOptionIsOpen"
                (change)="updateToggle($event)"
                [disabled]="isDisabled">
            </mat-slide-toggle>
        </div>
    </div>

    <ng-container *ngIf="disabledOptionIsOpen">
        <div *ngIf="!disableChannel" class="select-button">
            <div style="cursor: pointer" (click)="openChannelSelector()">
                {{ 'mimic.settings.system-integration.button.select' | translate }}
            </div>
            <div class="error-message">
                {{ 'mimic.settings.system-integration.button.select.error' | translate }}
            </div>
        </div>
        <ng-container *ngIf="disableChannel && !isLoadingChannel">
            <app-system-integration-channel
                [assignedChannel]="disableChannel"
                (onRemoveChannel)="removeAssignedChannel()"
                [removePadding]="true"
                (onOpenSelector)="openChannelSelector()">
            </app-system-integration-channel>
        </ng-container>
    </ng-container>

    <ng-container *ngIf="isLoadingChannel">
        <app-loading-spinner class="spinner-component"></app-loading-spinner>
    </ng-container>

    <ng-container *ngIf="disableChannel && !isLoadingChannel && disabledOptionIsOpen">
        <div class="fieldset-container">
            <fieldset class="fieldset" [class.selected]="showingStatusOptions">
                <legend class="legend" [class.selected]="showingStatusOptions">
                    {{ 'mimics.settings.button.disabled.state.legend' | translate }}
                </legend>
                <mat-select
                    class="input"
                    panelClass="disabled-status-panel"
                    [(ngModel)]="selectedStatus"
                    (openedChange)="showingStatusOptions = !showingStatusOptions">
                    <mat-option *ngFor="let status of statusOptions" [value]="status" class="disable-status-option">
                        {{ status }}
                    </mat-option>
                </mat-select>
            </fieldset>
            <div *ngIf="!selectedStatus" class="fieldset-error">
                {{ 'mimic.settings.system-integration.button.status.error' | translate }}
            </div>
        </div>
    </ng-container>
</div>
